<template>
  <button
    class="tw-link tw-inline-flex tw-items-center"
    @click="copyProfileLink"
  >
    {{ buttonText }}
    <CopyLinkIcon class="tw-ml-2 tw-h-4 tw-w-4" />
  </button>
</template>

<script setup>
import CopyLinkIcon from '@/assets/images/colored-icons/copy-link.svg'
import { ref } from 'vue'

const buttonText = ref('Copy profile link')

const copyProfileLink = () => {
  navigator.clipboard.writeText(window.location)
  buttonText.value = 'Copied!'
  setTimeout(() => {
    buttonText.value = 'Copy profile link'
  }, 2000)
}
</script>
